import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const liveBakeryCounterListDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.bakeryCounter,
  componentType: LAYOUT_COMPONENT_TYPE.liveBakeryCounterList,
  registryBlockKey: REGISTRY_BLOCK.presentation.liveBakeryCounterList,
  displayOrder: 4,
  content: {
    sectionTitle: loc3('Frisch aus dem Ofen', 'Fresh from the oven', 'Mới ra lò'),
    supporting: loc3(
      'Was gerade auf der Theke liegt — Status live.',
      'What’s on the counter right now — live status.',
      'Những gì đang trên quầy — trạng thái trực tiếp.',
    ),
    items: loc3(
      'Croissant Butter — frisch\nZimtschnecke — 3 übrig\nSourdough Laib — ausverkauft',
      'Butter croissant — fresh\nCinnamon bun — 3 left\nSourdough loaf — sold out',
      'Croissant bơ — mới\nBánh quế — còn 3\nBánh mì chua — hết',
    ),
  },
  media: {},
};
